module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/system-setting-component/setting-list/setting-list.component.scss
// module id = ./src/app/system-setting-component/setting-list/setting-list.component.scss
// module chunks = main